import { PropsWithChildren, useMemo } from 'react';

import { OrderContext, OrderContextProps } from './OrderContext';

export interface OrderProviderProps extends OrderContextProps {}

export const OrderProvider = ({
  children,
  schemas,
  orderType,
  directories,
  disabledDates,
  minEndDate,
  brokerTimezoneOffset,
}: OrderProviderProps & PropsWithChildren) => {
  const value = useMemo(
    () => ({
      schemas,
      orderType,
      directories,
      disabledDates,
      minEndDate,
      brokerTimezoneOffset,
    }),
    [
      schemas,
      orderType,
      directories,
      disabledDates,
      minEndDate,
      brokerTimezoneOffset,
    ]
  );

  return (
    <OrderContext.Provider value={value}>{children}</OrderContext.Provider>
  );
};
